export const getLocaleFromPath = (path: string): string | null => {
  if (path) {
    const match = path.match(/\/([a-z]{2}-[A-z]{2})(\/.*)?$/);
    if (match) {
      const parts = match[1].split('-');
      return parts[0].concat('-', parts[1].toUpperCase());
    }
  }
  return null;
};

export default {
  getLocaleFromPath,
};
